import React from "react"
import { Slider, Box, IconButton, Typography, TextField } from "@mui/material"
import AddIcon from "@mui/icons-material/Add"
import RemoveIcon from "@mui/icons-material/Remove"
import { Controller } from "react-hook-form"
import { commaSep } from "./helper"

const SliderComponent = ({ min = 0, max = 0, step = 0, control, name, ...props }) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={min}
      render={({ field: { onChange, value } }) => (
        <Box>
          <Slider
            value={value || 0}
            onChange={(e, newValue) => onChange(newValue)}
            aria-label='مبلغ'
            valueLabelDisplay='auto'
            marks
            min={min}
            max={max}
            step={step}
            size='large'
            sx={{ mb: 2 }}
          />
          <Box display='flex' justifyContent='center' alignItems='center' gap={1}>
            <IconButton
              onClick={() => onChange(Math.max(min, parseFloat(value) - step))}
              aria-label='decrement'
              size='large'
            >
              <RemoveIcon sx={{ borderRadius: "100%", border: 1 }} />
            </IconButton>
            <TextField
              fullWidth
              type='number'
              value={value || min}
              onChange={e => {
                let newValue = Number(e.target.value)
                if (newValue > max) newValue = max
                if (newValue < min) newValue = min
                onChange(newValue)
              }}
              inputProps={{ min, max, step }}
              {...props}
            />
            <IconButton
              onClick={() => onChange(Math.min(max, parseFloat(value) + step))}
              aria-label='increment'
              size='large'
            >
              <AddIcon sx={{ borderRadius: "100%", border: 1 }} />
            </IconButton>
          </Box>
          <Typography my={2}>مبلغ انتخاب شده: {commaSep(value || min)} ریال</Typography>
        </Box>
      )}
    />
  )
}

export default SliderComponent
